import React, { useState } from 'react';
import { Field, Form, FormSpy } from 'react-final-form';
import Box from '@mui/material/Box';
import Typography from './Modules/Components/Typography';
import AppFooter from './Modules/Views/AppFooter';
import { AppNavBar } from './Modules/Views/AppNavBar';
import AppForm from './Modules/Views/AppForm';
import { emailV, required } from './Modules/Form/validation';
import RFTextField from './Modules/Form/RFTextField';
import FormButton from './Modules/Form/FormButton';
import FormFeedback from './Modules/Form/FormFeedback';
import withRoot from './Modules/withRoot';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

function ForgotPassword() {
  const [sent, setSent] = useState(false);
  const [submitError, setSubmitError] = useState('');
  const navigate = useNavigate();

  const validate = (values: { [index: string]: string }) => {
    const errors = required(['email'], values);
    if (!errors.email) {
      const emailError = emailV(values.email);
      if (emailError) {
        errors.email = emailError;
      }
    }
    return errors;
  };

  const handleSubmit = async (values: { email: string }) => {
    setSent(true);
    setSubmitError('');

    try {
      const response = await axios.post('https://ipms.insollex.com/api/forgot', {
        email: values.email,
      });

      if (response.status === 200) {
        alert('Check your email for the reset link.');
        navigate('/signin', { replace: true });
      } else {
        setSubmitError('Failed to send reset link. Please try again.');
        setSent(false);
      }
    } catch (error: any) {
      console.error('Forgot password error:', error);
      setSubmitError('An unexpected error occurred. Please try again later.');
      setSent(false);
    }
  };

  return (
    <React.Fragment>
      <AppNavBar />
      <AppForm>
        <Typography variant="h3" gutterBottom marked="center" align="center">
          Forgot your password?
        </Typography>
        <Typography variant="body2" align="center">
          {"Enter your email address below and we'll send you a link to reset your password."}
        </Typography>

        <Form
          onSubmit={handleSubmit}
          subscription={{ submitting: true }}
          validate={validate}
        >
          {({ handleSubmit, submitting }) => (
            <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 6 }}>
              <Field
                autoFocus
                autoComplete="email"
                component={RFTextField}
                fullWidth
                label="Email"
                margin="normal"
                name="email"
                required
                size="large"
                disabled={submitting || sent}
              />

              {submitError && (
                <FormFeedback error sx={{ mt: 2 }}>
                  {submitError}
                </FormFeedback>
              )}

              <FormButton
                sx={{ mt: 3, mb: 2 }}
                disabled={submitting || sent}
                size="large"
                color="secondary"
                fullWidth
              >
                {submitting || sent ? 'Sending...' : 'Send reset link'}
              </FormButton>
            </Box>
          )}
        </Form>
      </AppForm>
      <AppFooter />
    </React.Fragment>
  );
}

export default withRoot(ForgotPassword);
